import { getAnonId } from '@/utils/anonId';
import { validateEnv } from '@/utils/validateEnv';
import { initFlagsmith as initFlagsmithBase } from '@resolve_medical_bills/flagsmith/react';

export const initFlagsmith = (): Promise<void> =>
  initFlagsmithBase({
    environmentID: validateEnv().VITE_FLAGSMITH_TOKEN,
    identity: getAnonId(),
    cacheFlags: true,
    enableAnalytics: true,
  });
